import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../lib/brand";

const dealTone = {
  Sale: "text-[#131311]",
  Purchase: "text-[#9a7b38]",
  Rent: "text-[#1eae53]",
};

const Card = ({ t }) => (
  <figure
    className="w-[300px] sm:w-[360px] shrink-0 rounded-3xl bg-[#ffffff] border border-[#e7e3d7] p-6 flex flex-col"
    data-testid={`testimonial-card-${t.name.toLowerCase()}`}
  >
    <div className="flex items-center justify-between">
      <Quote className="h-7 w-7 text-[#c5a059]" />
      <div className="flex gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5 fill-[#d4af37] text-[#d4af37]" />
        ))}
      </div>
    </div>
    <blockquote className="mt-4 text-[#3a382f] leading-relaxed text-[15px] flex-1">
      "{t.text}"
    </blockquote>
    <figcaption className="mt-5 pt-4 border-t border-[#e7e3d7] flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="h-9 w-9 rounded-full bg-[#131311] text-[#f0d98a] grid place-items-center font-serif text-lg">
          {t.name[0]}
        </span>
        <span className="font-semibold text-[#131311]">{t.name}</span>
      </div>
      <span className={`text-xs font-semibold uppercase tracking-wide ${dealTone[t.deal]}`}>
        {t.deal}
      </span>
    </figcaption>
  </figure>
);

export const Testimonials = () => {
  const half = Math.ceil(TESTIMONIALS.length / 2);
  const rowA = [...TESTIMONIALS.slice(0, half), ...TESTIMONIALS.slice(0, half)];
  const rowB = [...TESTIMONIALS.slice(half), ...TESTIMONIALS.slice(half)];

  return (
    <section id="reviews" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 text-center mb-10 sm:mb-14">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-[#c5a059]" />
          <span className="text-xs tracking-[0.34em] uppercase text-[#9a7b38] font-semibold">
            Client Voices
          </span>
          <span className="h-px w-10 bg-[#c5a059]" />
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#131311] leading-[1]">
          Trusted by families <span className="italic text-gold-gradient">across Hisar.</span>
        </h2>
      </div>

      <div className="relative space-y-5">
        <div className="relative">
          <div className="lj-testi-track">
            {rowA.map((t, i) => (
              <Card key={`a-${i}`} t={t} />
            ))}
          </div>
        </div>
        <div className="relative">
          <div className="lj-testi-track rev">
            {rowB.map((t, i) => (
              <Card key={`b-${i}`} t={t} />
            ))}
          </div>
        </div>

        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-[#faf9f5] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-[#faf9f5] to-transparent" />
      </div>
    </section>
  );
};
